import React from 'react';
import { CheckSquare, Info } from 'lucide-react';

const AdditionalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <CheckSquare className="w-5 h-5 mr-2 text-indigo-500" />
        Дополнительные параметры расчета
      </h3>
      
      <div className="grid grid-cols-1 gap-4">
        {/* Услуги юриста */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeLawyerFees"
              checked={formData.includeLawyerFees}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать услуги юриста/представителя
            </span>
          </label>
        </div>

        {/* Судебная экспертиза */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeExpertFees"
              checked={formData.includeExpertFees}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать расходы на судебную экспертизу
            </span>
          </label>
        </div>

        {/* Прочие расходы */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeOtherExpenses"
              checked={formData.includeOtherExpenses}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Учитывать иные судебные расходы
            </span>
          </label>
        </div>

        {/* Льготы по оплате госпошлины */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="applyBenefits"
              checked={formData.applyBenefits}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Применить льготы по уплате госпошлины
            </span>
          </label>
        </div>

        {/* Рассрочка по оплате госпошлины */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="installmentPlan"
              checked={formData.installmentPlan}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Рассрочка уплаты госпошлины
            </span>
          </label>
        </div>
      </div>

      <div className="mt-4 bg-indigo-50 dark:bg-indigo-900/30 p-3 rounded-lg border border-indigo-100 dark:border-indigo-800">
        <div className="flex items-start">
          <Info className="w-5 h-5 text-indigo-600 dark:text-indigo-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-indigo-700 dark:text-indigo-300 mb-1">
              Важная информация
            </h4>
            <p className="text-xs text-indigo-600 dark:text-indigo-400">
              При включении дополнительных расходов в расчет вы получите более точную оценку общей стоимости
              судебного процесса. При этом размер госпошлины всегда рассчитывается автоматически
              в соответствии с действующим законодательством.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalParametersSection;